<template>
	<div style="box-sizing: border-box;padding: 10px;min-height: 100%;" v-loading="loading">
		<v-jstree ref="jstree" size="small" text-field-name="name" value-field-name="id" :data="policylist" collapse
			@item-click="itemClick" v-if="policylist.length!=0"></v-jstree>
	</div>
</template>
<style scoped>


</style>
<script>
	import VJstree from 'vue-jstree'
	export default {
		props: {

		},
		data() {
			return {
				loading: false,
				policylist: [],
				currentObj: null,
				currentItem: {
					id: 0,
					name: ''
				},
			}
		},
		created() {
			this.list()
		},
		mounted() {

		},
		watch: {

		},
		computed: {

		},

		methods: {
			list() {
				this.loading = true
				this.policylist = []
				this.$api.purchase.listpolicy().then((res) => {
					let list = []
					res.forEach((item) => {
						let name = item.policyName
						if (item.cache != 0) {
							name = item.policyName + '【' +this.minutesSince(item.cachetime*1000) + 'm】'
						}
						item.icon = ''
						item.name = name
						list.push(item)
					})
					this.policylist = list
					this.loading = false
				})
			},
			itemClick(e) {
				this.currentObj = e
				this.currentItem = e.model
				this.$emit('select', this.currentItem)
			},
			updateNode(node) {
				for (let i in node) {
					this.currentItem[i] = node[i]
				}
			},
			addNode(node) {
				this.currentItem.addChild(node)
			},
			removeNode() {
				let index = this.currentObj.parentItem.indexOf(this.currentItem)
				this.currentObj.parentItem.splice(index, 1)
			},
			unSelectNode() {
				this.currentItem.selected = false
				this.currentItem = {
					id: 0,
					name: ''
				}
			},
			minutesSince(timestamp) {
				const givenTime = new Date(timestamp);
				const currentTime = new Date();
				const timeDifference = currentTime - givenTime;
				const minutesDifference = timeDifference / (1000 * 60);
				return Math.floor(minutesDifference);
			}

		},
		components: {
			VJstree
		}
	}
</script>
